import { Component, input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { environment } from '@env/environment';

@Component({
    selector: 'app-spinner-loader',
    imports: [MatProgressSpinnerModule],
    templateUrl: './spinner-loader.component.html',
    styleUrl: './spinner-loader.component.scss',
})
export class SpinnerLoaderComponent {
    message = input.required<string>();
    readonly logoUrl = `${environment.defaultUrl}assets/images/ul-logo.svg`;
}
